<template>
  <div class="project-container">
    <ProjectManager :companyUID="user_company" v-if="!user_project && user_company" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProjectManager from "@/views/project/components/project-manager";
export default {
  components: {
    ProjectManager,
  },
  computed: {
    ...mapGetters(['user_company', 'user_project']),
  },
  created(){
    if(this.user_project){
      this.$router.push('/project/'+ this.user_project)
    }
  }
};
</script>

<style>
</style>